<template>
  <div :class="'toast toast-' + data.type" style="display: block" @click="click" v-on:mouseover="onMouseOver" v-on:mouseout="onMouseOut" >
    <div class="toast-title" v-html="data.title"></div>
    <div class="toast-message" v-html="data.msg"></div>
  </div>
</template>

<script setup>
  import { onMounted, ref, nextTick, getCurrentInstance, computed } from 'vue'

  const emit = defineEmits(['setInterval'])

  const props = defineProps({
    data: Object,
  })

  const instance = getCurrentInstance()
  let intervalId = props.data.intervalId

  onMounted(() => {
    if (props.data.timeout) {
      setTimeoutFunc()
    }
  })

  // Enter Hover
  function onMouseOver () {
    if (props.data.onMouseOver) {
      props.data.onMouseOver()
    }

    if (props.data.closeOnHover && intervalId) {
      clearInterval(intervalId)
    }
  }

  // Leave Hover
  function onMouseOut () {
    if (props.data.onMouseOut) {
      props.data.onMouseOut()
    }
    if (props.data.closeOnHover) {
      props.setTimeout()
    }
  }

  // Set timeout to close
  function setTimeoutFunc () {
    intervalId = setTimeout(() => {
      close()
    }, props.data.timeout)
  }

  // Clicked Toast
  function click () {
    if (props.data.onClick) {
      props.data.onClick()
    }

    if (props.data.clickClose) {
      close()
    }
  }

  // Close Toast
  function close () {
    // if toast not manually closed
    if (instance.parent !== null) {
      emit("setInterval", props.data)
    }
  }
</script>
